import { createFileRoute } from "@tanstack/react-router";
import CitiesHub from "@/pages/CitiesHub";
import { routeHead } from "@/lib/seo/route-head";
import { listingsV2QueryOptions } from '@/lib/queries/publicData';

export const Route = createFileRoute("/de/stadte-hub/")({
  loader: async ({ context }) => ({ cityHubRows: await context.queryClient.ensureQueryData(listingsV2QueryOptions({ country_code: 'DE', limit: 2000 })) }),
  head: () => routeHead("/de/stadte-hub/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CitiesHub />
  );
}
